// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseButton from 'shared/components/Button';

export const Container = styled.form`
  .nd-container {
    display: flex;
    
  }

  .nd-email {
    height: 48px;
    ${({ theme }) => theme.typography.bodyLarge};
    ${({ theme }) => `
      color: ${theme.colors.textPrimary};
      background-color: ${theme.colors.surface};
      border: 0.5px solid ${theme.colors.surfaceInverse};
      padding: 0 ${theme.spacing.spacing80};    
    `}
    &:focus {
      outline: 0;
      background-color: ${({ theme }) => theme.colors.surface};
    }

    &:-webkit-autofill {
      background-color: ${({ theme }) => theme.colors.surface};
      -webkit-text-fill-color: ${({ theme }) => theme.colors.textPrimary} !important;
      -webkit-box-shadow: 0 0 0px 1000px ${({ theme }) => theme.colors.surface} inset;
    }
  }

  .nd-text {
    width: 100%;
    ${({ theme }) => theme.typography.bodyMedium};
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-top: ${({ theme }) => theme.spacing.spacing60};
  }
`;

export const Button = styled(BaseButton)`
  width: 140px;
  height: 48px;
  ${({ theme }) => theme.typography.subTitleLarge};
  border-radius: ${({ theme }) => `0 ${theme.borders.buttonBorderRadius} ${theme.borders.buttonBorderRadius} 0`};

  &:not([disabled]):hover,
  /* &:hover {
    background: ${({ theme }) => theme.colors.stateHover};
  } */
`;
